import { Resource } from '@yandex-int/k-common';
import { format } from 'date-fns';
import { POPUP_THEMES, POPUP_DIRECTIONS, HELP_TYPE } from 'platform-components/constants';
import { IntlShape } from 'react-intl';

export const getStubValue = (intl: IntlShape): string => intl.formatMessage({ id: 'lessonView.results.cellStub' });

export const getCellValue = (value: string | number | null, intl: IntlShape): string | number =>
    value || getStubValue(intl);

export const getCellTime = (time: number, timeFormat: string = 'mm:ss'): string => {
    return time ? format(time * 1000, timeFormat) : '';
};

export const getSticker = (resource: Resource | null | undefined, intl: IntlShape): string => {
    const src = resource?.file;
    if (src) {
        return src;
    }

    return intl.formatMessage({ id: 'lessonView.results.emptySticker.image.src' });
};

export const helpProps = {
    mix: 'results__help',
    popupProps: {
        theme: POPUP_THEMES.SCHOOL,
        direction: POPUP_DIRECTIONS.TOP,
        offsetTop: -12,
        hasArrow: true,
        inLayer: true,
    },
    type: HELP_TYPE.INFO,
};
